export default class {
  constructor(el) {
    const iframes = Array.from(el.querySelectorAll('iframe'))

    if (iframes.length) {
      window.addEventListener('message', (e) => {
        if (e.data && e.source) {
          let message = e.data

          try {
            message = JSON.parse(e.data)
          } catch (e) {
            message = e.data
          }

          if (message?.height) {
            const targetIframe = iframes.find(
              (iframe) => iframe.contentWindow === e.source,
            )

            if (targetIframe) {
              targetIframe.style.height = message.height + 'px'
            }
          }
        }
      })
    }
  }
}
